import { render, staticRenderFns } from "./customer_sysuser_edit.vue?vue&type=template&id=73618b06&scoped=true"
import script from "./customer_sysuser_edit.vue?vue&type=script&lang=js"
export * from "./customer_sysuser_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73618b06",
  null
  
)

export default component.exports